export default __webpack_public_path__ + "static/media/icn_ybx.be0b0e39.svg";